/* JS bundle for the d3 graphs */

import { select as d3select } from "d3-selection"
import * as d3scale from "d3-scale"
import * as d3array from "d3-array"

window.d3select = d3select
window.d3scale = d3scale
window.d3array = d3array
